import { Provider } from "react-redux";
import {
  BrowserRouter,
  Redirect,
  Route,
  Switch,
  useLocation,
} from "react-router-dom";
import Auth from "./layout/Auth";
import Main from "./layout/Main";
import routes from "./routes";
import store from "./store";
import { useEffect } from "react";

function App() {
  return (
    <>
      <Provider store={store}>
        <BrowserRouter>
          <Switch>
            {routes.map((route) => {
              /*
                                Routes are exact unless they say otherwise.
                                /account opts out (`exact: false`) because
                                AccountLayout routes its own five pages
                                underneath it.
                            */
              const exact = route.exact !== false;
              switch (route.layout) {
                case "main":
                  return (
                    <Route key={route.path} exact={exact} path={route.path}>
                      <Main>
                        <route.component />
                      </Main>
                    </Route>
                  );
                case "auth":
                  return (
                    <Route key={route.path} exact={exact} path={route.path}>
                      <Auth>
                        <route.component />
                      </Auth>
                    </Route>
                  );
                default:
                  return null;
              }
            })}
            <Redirect to="/api/overview" />
          </Switch>
        </BrowserRouter>
      </Provider>
    </>
  );
}

export default App;
